<template>
  <div class="flex act-container">
    <div class="add-goods-container">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="130px"
        >
          <el-form-item label="计划标题：" prop="planTitle">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.planTitle"
              placeholder="请输入计划标题(100字以内)"
              maxlength="100"
              :disabled="showGoods==='yes'"
            ></el-input>
          </el-form-item>
          <el-form-item label="直播门店：" prop="shopIdList" v-show="showGoods==='no'">
            <el-select
              clearable
              v-model="ruleForm.shopIdList"
              placeholder="请选择门店"
              size="small"
              filterable
              @change="getCheckedStore"
              multiple
              v-if="
                storeCode != '53010017032439' && storeCode != '42010216070190'
              "
            >
              <el-option
                label="全部门店"
                :disabled="selectOther"
                value="all"
              ></el-option>
              <el-option
                :label="v.shopName"
                :value="v.shopId"
                :disabled="selectAll"
                v-for="(v, i) in microShopStoreList"
                :key="i"
              ></el-option>
            </el-select>

            <el-select
              clearable
              v-model="ruleForm.shopIdList"
              placeholder="请选择门店"
              size="small"
              filterable
              @change="getCheckedStore"
              multiple
              v-if="
                storeCode === '53010017032439' || storeCode === '42010216070190'
              "
            >
              <el-option
                label="全部门店"
                :disabled="selectOther"
                value="all"
              ></el-option>
              <el-option
                :label="v.shopName"
                :value="v.shopId"
                :disabled="selectAll"
                v-for="(v, i) in dkMicroShopStoreList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品默认图：" prop="goodsMainImg" v-show="showGoods==='no'">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="750"
              :height="750"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>
            <el-button
              type="primary"
              size="small"
              v-show="!listHeaderImgUrl"
              @click="toggleShow"
              >上传</el-button
            >
            <span class="form-tip">图片尺寸建议750x750（最多上传一张）</span>
            <div class="priview" v-if="listHeaderImgUrl">
              <img :src="listHeaderImgUrl" alt="主图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="toggleShow">更换</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="默认配送方式：" prop="deliveryMode" v-show="showGoods==='no'">
            <el-checkbox-group
              v-model="ruleForm.deliveryMode"
              @change="deliveryModeChange"
            >
              <el-checkbox
                v-for="(v, i) in deliveryList"
                :label="v.value"
                :key="i"                
                >{{ v.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
              label="运费模板："
              prop="expressId"
              v-if="expressFlag"
              v-show="showGoods==='no'"
            >
              <el-select
                size="small"
                v-model="ruleForm.expressId"
                filterable
                class="ml10"
                clearable
                placeholder="请选择运费模板"
              >
                <el-option
                  :label="v.expressName"
                  :value="v.expressId"
                  v-for="(v, i) in expressList"
                  :key="i"
                ></el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="下单模式选择" prop="selectOrderMode" v-show="showGoods==='no'">
            <el-radio-group v-model="ruleForm.selectOrderMode">
              <el-radio label="normal" value="normal">常规下单</el-radio>
              <el-radio label="quick" value="quick">快捷下单</el-radio>
            </el-radio-group>
            <div class="quick-wrap" v-show="ruleForm.selectOrderMode==='quick'">
              <div class="item flex">
                <div class="label">选择快捷下单绑定的商品</div>
                <div class="content">
                    <!-- <el-input v-model.trim="goodsSn" placeholder="输入条码绑定"></el-input> -->
                    <el-input
                      size="small"
                      class="mr10 ipt"
                      style="width: 270px"
                      v-model.trim="ruleForm.wxshopSpuName"
                      placeholder="请选择绑定商品"
                      @click.native="selectGood"
                      readonly
                    ></el-input>
                </div>
              </div>
              
              <div class="item flex">
                <div class="label">输入快捷下单校验的金额范围：</div>
                <div class="content flex">
                  <span class="mr10">包含输入的值</span>
                  <div class="input-range">
                    <el-input-number v-model.trim="ruleForm.minSelectPayAmount" placeholder="最小值" :max="99999999.99" :controls="false" :precision="2" :step="0.1" :min="0.01"></el-input-number>
                    <span class="ml10 mr10">-</span>
                    <el-input-number v-model.trim="ruleForm.maxSelectPayAmount" placeholder="最大值" :max="99999999.99" :controls="false" :precision="2" :step="0.1" :min="0.01"></el-input-number>
                  </div>
                </div>
              </div>
            </div>
          </el-form-item>

          <div v-show="showGoods==='yes'">
            <div class="flex">
              <el-button
                class="mb20"
                @click="addGoods"
                type="primary"
                size="small"
                >添加商品
              </el-button>
              <el-button
                class="mb20 ml20"
                @click="refreshStockNum"
                type="primary"
                size="small"
                >刷新库存
              </el-button>
            </div>
          </div>
          <!--添加商品 -->
          <div class="mt20" v-show="showGoods==='yes'">
            <el-table
              :data="ruleForm.spuInfoModelList"
              row-key="wxshopSkuId"
              border
              stripe
              height="500"
              style="width: 100%"
            >
              <!-- <el-table-column 
                header-align="center"
                align="center" 
                type="index" 
                label="序号" 
                width="50">
              </el-table-column> -->
              <el-table-column
                header-align="center"
                align="center"
                prop="seqNum"
                label="编号"
                width="80"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="商品名称"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuMainPic"
                label="商品图片"
              >
              <template slot-scope="scope">
                <el-image
                  :src="scope.row.spuMainPic"
                  alt="主图"
                  :preview-src-list="[scope.row.spuMainPic]"
                  style="width:100px;height:100px;"
                  />
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="wxshopPrice"
                label="商品价格"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="stockNum"
                label="商品库存"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="eachMemberPurchaseLimit"
                label="限购"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="deliveryModeName"
                label="提货方式"
                width="100"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="liveShow"
                label="状态"
              >
              <template slot-scope="scope">
                <div class="danger" v-if="scope.row.liveShow==='yes'">显示</div>
                <div v-else-if="scope.row.liveShow==='no'">隐藏</div>
              </template>  
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button type="text" @click="cancelLiveShow(scope.$index, scope.row)" v-if="scope.row.liveShow==='yes'"
                    >取消展示</el-button
                  >
                  <el-button type="text" @click="addLiveShow(scope.$index, scope.row)" v-else
                    >推送展示</el-button
                  >
                  <el-button type="text" @click="deleteGoodChild(scope.$index, scope.row)" v-if="scope.row.liveShow==='no'"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="flex flex-center mt20">
            <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm')"
              v-if="showGoods==='no'"
              >提交</el-button
            >
            <!-- <el-button
              type="primary"
              size="small"
              @click="submitForm('ruleForm','stay')"
              v-if="type==='edit' && showGoods==='no'"
              >保存</el-button
            > -->
            <el-button size="small" @click="$router.back(-1)">返回</el-button>
          </div>
        </el-form>
      </div>
    </div>

    <el-dialog
      title="添加商品"
      :visible.sync="dialogAddGoods"
      :close-on-click-modal="false"
    >
      <el-form
        :model="ruleFormAddGoods"
        :rules="ruleFormAddGoodsrules"
        ref="ruleFormAddGoods"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="商品名称:" prop="spuName">
            <el-input
              style="width: 360px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleFormAddGoods.spuName"
              placeholder="请输入商品名称"
              maxlength="100"
            ></el-input>
          </el-form-item>  
          <el-form-item label="商品图片:" prop="spuMainPic">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormAddGoods.spuMainPic"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="priview2" v-if="ruleFormAddGoods.spuMainPic">
              <el-image
                class="image"
                :src="ruleFormAddGoods.spuMainPic"
                alt="商品图片"
                :preview-src-list="[ruleFormAddGoods.spuMainPic]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="ruleFormAddGoods.spuMainPic">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品价格:" prop="wxshopPrice">
            <el-input
              maxlength="30"
              @mousewheel.prevent.native
              style="width: 360px"
              v-model.trim="ruleFormAddGoods.wxshopPrice"
              size="small"
              @input="filterGt0OrFixed2AddGoods('wxshopPrice')"
              placeholder="请输入商品价格"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="可售库存:" prop="stockNum">
            <el-input
              size="small"
              class="mr10 ipt"
              style="width: 360px"
              clearable
              v-model.trim="ruleFormAddGoods.stockNum"
              @input="filterGt0OrFixed3AddGoods('stockNum')"
              placeholder="请选择可售库存"
            ></el-input>
          </el-form-item>
          <el-form-item label="每人限购:" prop="eachMemberPurchaseLimit">
            <el-input
              size="small"
              class="mr10 ipt"
              style="width: 360px"
              clearable
              v-model.trim="ruleFormAddGoods.eachMemberPurchaseLimit"
              @input="filterGt0OrFixed4AddGoods('eachMemberPurchaseLimit')"
              placeholder="请输入每人限购"
            ></el-input>
            <span class="form-item-tip">默认-1 表示不限购</span>
          </el-form-item>
          <el-form-item class="mb10" label="配送方式:" prop="deliveryMode">
            <el-checkbox-group
              v-model="ruleFormAddGoods.deliveryMode"
              @change="deliveryModeChangeAddGoods"
            >
              <el-checkbox
                v-for="(v, i) in deliveryList"
                :label="v.value"
                :key="i"                
                >{{ v.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="运费模板："
            prop="expressId"
            v-if="expressFlag"
          >
            <el-select
              size="small"
              v-model="ruleFormAddGoods.expressId"
              filterable
              class="ml10"
              clearable
              placeholder="请选择运费模板"
            >
              <el-option
                :label="v.expressName"
                :value="v.expressId"
                v-for="(v, i) in expressList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitruleFormAddGoods('ruleFormAddGoods')"
            >保存</el-button
          >
          <el-button size="small" @click="dialogAddGoods = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>

    <hm-filter-m-s-goods
      type="microShop"
      :visible="dialogVisible"
      :radio="isRadio"
      @saveGoods="saveGoods"
      @setLink="setLink"
      @close="dialogVisible = false"
    ></hm-filter-m-s-goods>

    <el-dialog
      custom-class="import-dialog"
      title="添加商品"
      width="70%"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <div class="p20">
        <div class="table-panel flex flex-between">
          <div class="flex text-right flex-end">
            <el-input
              clearable
              style="width: 200px"
              v-model.trim="searchDialogCondition.keyWords"
              placeholder="请输入货号/条码/商品名称"
              size="small"
              class="ipt mr10"
            ></el-input>

            <el-input
              clearable
              v-model.trim="searchDialogCondition.minPrice"
              placeholder="最低零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-input
              clearable
              v-model.trim="searchDialogCondition.maxPrice"
              placeholder="最高零售价"
              size="small"
              style="width: 100px"
              class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchGoods"
              >查询</el-button
            >
            <el-button
              type="info"
              size="small"
              @click="searchDialogCondition = {}"
              >重置</el-button
            >
          </div>
        </div>
        <div class="table mb20">
          <div class="tips mb20">提示：点击表格行即可选择</div>
          <el-table
            stripe
            border
            ref="brandTable"
            @current-change="handleCurrentChange"
            highlight-current-row
            @selection-change="getChecked"
            :data="virtualGoods.records"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              type="index"
              label="序号"
              :index="
                index => index + (currentVirtualPage - 1) * pageVirtualSize + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="wxshopSpuName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsSnAndBarcode"
              show-overflow-tooltip
              label="规格"
            >
              <template slot-scope="scope">
                <div>
                  <!-- <span>{{ scope.row.spuAttributeValueList.join() }}</span> -->
                  <span>{{ scope.row.specIdGroupName }}</span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="类别"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="categoryName"
              label="价格信息"
            >
              <template slot-scope="scope">
                <div>
                  <span>零售价：</span>
                  <span class="rose">{{ scope.row.wxshopPrice }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="virtualGoods.total"
            @current-change="pagingVirtual"
            @size-change="handleSizeVirtualChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentVirtualPage"
          ></el-pagination>
        </div>
        <div class="btn-wrapper mb20 flex flex-center">
          <el-button size="small" type="primary" @click="saveGoods2"
            >确 定</el-button
          >
          <el-button size="small" @click="dialogVisible2 = false"
            >取 消</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { setCookie, getCookie, queryActivityCategory } from "../../utils/utils";
import HmFilterMSGoods from "@/components/HmFilterMSGoods";
import { arrayUnique2 } from "@/utils/utils";
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import HmForm from "@/components/HmForm2";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
import { getLoginUser,getUserName } from "@/utils/auth";
export default {
  components: {
    myUpload,
    HmRichEditor,
    HmForm,
    actPreview,
    HmFilterMSGoods,
  },
  data() {
    const validateOrderMode = (rule, value, callback) => {
      if(this.ruleForm.selectOrderMode === "quick") {
        const {
          selectWxshopSkuId,
          minSelectPayAmount,
          maxSelectPayAmount
        } = this.ruleForm
        console.log(selectWxshopSkuId,
          minSelectPayAmount,
          maxSelectPayAmount);
        if(!selectWxshopSkuId || (!minSelectPayAmount && minSelectPayAmount!==0) || (!maxSelectPayAmount && maxSelectPayAmount!==0)){  
          return callback(new Error("请填写完整信息"))
        } else {
          if(minSelectPayAmount > maxSelectPayAmount) {
            return callback(new Error("最小值不能大于最大值"))
          }
          return callback()
        }
      } else {
        return callback()
      }
    };
    return {
      deliveryList: [
        {
          name: "门店自提",
          value: "mdzt",
        },
        {
          name: "快递发货",
          value: "kdfh",
        },
        {
          name: "同城配送",
          value: "tcps",
        },
      ],
      storeCode: "",
      selectOther: false,
      selectAll: false,
      isRadio: true,
      dialogVisible: false,
      listHeaderImgUrl: "https://imgcdn.hemiao100.com/mall/10349ebb45abbe2f66af250470fc129.png",
      ruleForm: {
        planTitle: "",
        shopIdList:[],
        goodsMainImg: "",
        deliveryMode: [],
        expressId: "",
        spuInfoModelList: [],
        goodsRelModelList: [],
        selectOrderMode: "normal",
        selectWxshopSkuId: "",
        minSelectPayAmount: undefined,
        maxSelectPayAmount: undefined
      },
      rules: {
        planTitle: [
          {
            required: true,
            message: "请输入计划标题",
            trigger: "blur"
          },
          {
            min: 2,
            max: 100,
            message: "长度在 2 到 100 个字符",
            trigger: "blur"
          }
        ],
        shopIdList: {
          required: true,
          message: "请选择门店",
          trigger: "change"
        },
        deliveryMode: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur"
        },
        selectOrderMode: {
          required: true,
          validator: validateOrderMode,
          trigger: 'change'
        }
      },
      expressList: [],
      id: this.$route.query.id,
      type: this.$route.query.type,
      showGoods: this.$route.query.showGoods,
      index: 0,
      goodsRuleModelList: [],
      updateMode: "",
      columnsInfoModels: null,
      isSaving: false,
      uploadShow: true,
      show: false,
      expressFlag: false,
      dialogAddGoods: false,
      ruleFormAddGoods: {
        createBy:"",
        isMultCodes: false,
        spuName:"",
        goodsSn:"",
        spuBarcode:"",
        brandId:"",
        brandName:"",
        categoryId:"",				
        categoryName:"",
        attributeValue:"",
        categoryRelModelList:[],
        categoryRelModelListShow:[{
            wxshopCategoryId:"",
            categoryName:"",
        }],
        spuAttributeList:[],
        netWeight:"",
        grossWeight:"",
        weightUnit:"g",
        weightUnitName:"克",
        recommendedRetailPrice:"",
        supplierId:"",
        supplierName:"",
        spuMainPic:"",      
        spuSlideShowPicList: [],          
        spuDetails:"",
        spuType:"reality",                
        overstockSales:"open",
        overstockSalesMode:"day",
        overstockSalesState:true,
        deliveryDeadline:"",
        deliveryDeadlineDate:"",
        deliveryDeadlineTime:"",
        afterPayDays:"0",
        couponUsable:"yes",
        couponUsableState:true,
        basePrice:"",
        wxshopPrice:"",
        markingPrice:"",
        stockNum: "",
        purchaseLimitType:"noLimit",
        eachMemberPurchaseLimit:-1,
        salesStartTime:"",
        salesStartTimeDate:"",
        salesStartTimeTime:"",
        upStartTime:"",
        upStartTimeDate:"",
        upStartTimeTime:"",
        downStartTime:"",
        downStartTimeDate:"",
        downStartTimeTime:"",
        memberGroupRelModelList:[],
        memberGroupRelModelList2:[],
        memberGroupRelModelListShow:[],
        shopModelList:[],
        shopModelListShow:[],
        deliveryMode:[],
        expressId:"",
        expressName:"",
        specificationList: [
            {
                specName: "",
                specName2: "",
                specId: "",
                specModels: [],
                attr:[],
                nameList:[],
            }
        ],
        skuModelList:[],
        deliveryModeName: "",
        liveShow: "no",
      },
      ruleFormAddGoodsrules: {
        spuName:[
          {
            required: true,
            message: "请输入商品名称",
            trigger: "blur"
          },
        ],
        spuMainPic:[
          {
            required: true,
            message: "请上传商品图片",
            trigger: "blur"
          },
        ],
        wxshopPrice:[
          {
            required: true,
            message: "请输入商品价格",
            trigger: "blur"
          },
        ],
        stockNum:[
          {
            required: true,
            message: "请选择可售库存",
            trigger: "blur"
          },
        ],
        eachMemberPurchaseLimit:[
          {
            required: true,
            message: "请输入每人限购",
            trigger: "blur"
          },
        ],
        deliveryMode: {
          required: true,
          message: "请选择配送方式",
          trigger: "blur"
        },
        expressId: {
          required: true,
          message: "请选择运费模板",
          trigger: "blur"
        },
      },
      addSpuInfoModelList: [],
      removeGoodsIdList: [],
      goodsSn: "",
      minMoney: undefined,
      maxMoney: undefined,
      currentVirtualPage: 1,
      pageSize: 10,
      searchDialogCondition: {},
      pageVirtualSize: 10,
      dialogVisible2: false,
      currentRow: {},
    };
  },
  created() {
    this.queryExpressList();
    console.log("showGoods:",this.showGoods);
  },
  mounted() {
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    console.log("this.storeCode:", this.storeCode);
    if (storeCode === "42010216070190" || storeCode === "53010017032439") {
      this.$store.dispatch("queryDkMicroStoreList");
    } else {
      this.$store.dispatch("queryMicroStoreList");
    }
    //  修改
    if (this.id) {
      this.queryDetails();
    }
    this.$store.dispatch("queryStoreStyle");
    console.log("this.type:",this.type);
  },
  computed: mapGetters([
    "storeStyle",
    "microShopStoreList",
    "dkMicroShopStoreList",
    "virtualGoods"
  ]),
  methods: {
    async queryExpressList() {
      const { result } = await this.$store.dispatch("storeExpressConfigList");
      this.expressList = [];
      if (result.defaultTemplate) {
        this.expressList.push(result.defaultTemplate);
        this.ruleForm.expressId = result.defaultTemplate.expressId;
      }
      this.expressList.push(...result.templateList);
    },
    deliveryModeChange(val) {
      if (val.indexOf("kdfh") < 0) {
        this.expressFlag = false;
        this.ruleForm.expressId = "";
      } else {
        this.expressFlag = true;
      }
    },
    deliveryModeChangeAddGoods(val) {
      if (val.indexOf("kdfh") < 0) {
        this.expressFlag = false;
        this.ruleFormAddGoods.expressId = "";
      } else {
        this.expressFlag = true;
      }
    },
    getCheckedStore(storeList) {
      this.selectOther = storeList.findIndex((o) => o !== "all") > -1;
      this.selectAll = storeList.findIndex((o) => o === "all") > -1;
      if (this.selectAll) {
        this.ruleForm.shopIdList = ["all"];
      }
    },
    // 从列表页跳转过来的修改活动 id
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryByIdLivePlan", {
        id: this.id,
      });
      for (let key in this.ruleForm) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
      this.listHeaderImgUrl = this.ruleForm.goodsMainImg;
      if(this.ruleForm.deliveryMode){
        this.ruleForm.deliveryMode = JSON.parse(this.ruleForm.deliveryMode);
        this.ruleForm.deliveryMode.forEach(v=>{
          if(v==='kdfh'){        
            this.expressFlag = true;
          }
        })
      }
      this.ruleForm.spuInfoModelList = this.ruleForm.goodsRelModelList || [];
      if(this.ruleForm.goodsRelModelList && this.ruleForm.goodsRelModelList.length){
        this.ruleForm.spuInfoModelList.forEach(v=>{
          v.spuName = v.wxshopSpuVo.wxshopSpuName;
          v.spuMainPic = v.wxshopSpuVo.spuMainPic;
          v.wxshopPrice = v.wxshopSpuVo.wxshopPrice;
          v.stockNum = v.wxshopSpuVo.stockNum;
          v.eachMemberPurchaseLimit = v.wxshopSpuVo.eachMemberPurchaseLimit;
          v.deliveryModeName = "";
          if(v.wxshopSpuVo.deliveryModelList){
            v.wxshopSpuVo.deliveryModelList.forEach(p=>{
              this.deliveryList.forEach(o=>{
                if(p===o.value){
                  v.deliveryModeName += o.name + "，"
                }
              })
            })
          }
        })
      }
      this.removeGoodsIdList = [];
      this.addSpuInfoModelList = [];
      if(this.showGoods==='no' && result.selectWxshopSpuId){
        this.$store.dispatch('spuDetail', {
            storeCode: this.storeCode,
            wxshopSpuId: result.selectWxshopSpuId,
          }).then(res => {
            let wxshopSpuName = res.result.wxshopSpuName
            this.$store.dispatch('skuSpecDetail', {
              storeCode: this.storeCode,
              wxshopSpuId: result.selectWxshopSpuId
            }).then(res2 => {
              console.log('---res----', res);
              Object.keys(res2.result.skuData).forEach(v => {
                if(res2.result.skuData[v].wxshopSkuId == result.selectWxshopSkuId) {
                    wxshopSpuName += v
                }
              })
              this.$set(this.ruleForm, 'wxshopSpuName', wxshopSpuName);
              console.log('this.ruleForm.wxshopSpuName', this.ruleForm.wxshopSpuName);
            })
        })
      }
    },    
    addGoods() {
      this.ruleFormAddGoods.spuName = "";
      this.ruleFormAddGoods.wxshopPrice = "";
      this.ruleFormAddGoods.stockNum = "";
      this.ruleFormAddGoods.eachMemberPurchaseLimit = "-1";
      this.ruleFormAddGoods.deliveryMode = this.ruleForm.deliveryMode;
      this.ruleFormAddGoods.expressId = this.ruleForm.expressId;
      this.ruleFormAddGoods.spuMainPic = this.listHeaderImgUrl;
      this.addSpuInfoModelList = [];
      this.removeGoodsIdList = [];
      this.dialogAddGoods = true;
    },
    filterGt0OrFixed2(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop].replace(
          /\.{2,}/g,
          "."
        ); //两个连续的"."仅保留第一个"."
      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
        ); //限制只能输入两个小数
      if (
        this.ruleForm.spuInfoModelList[i][prop].indexOf(".") < 0 &&
        this.ruleForm.spuInfoModelList[i][prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleForm.spuInfoModelList[i][prop] = parseFloat(
          this.ruleForm.spuInfoModelList[i][prop]
        );
      }
    },
    filterGt0OrFixed2AddGoods(prop, i) {
      // this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormAddGoods[prop] =
        this.ruleFormAddGoods[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleFormAddGoods[prop] =
        this.ruleFormAddGoods[prop].replace(
          /\.{2,}/g,
          "."
        ); //两个连续的"."仅保留第一个"."
      this.ruleFormAddGoods[prop] =
        this.ruleFormAddGoods[prop]
          .replace(".", "$#*")
          .replace(/\./g, "")
          .replace("$#*", "."); //去除其他"."
      this.ruleFormAddGoods[prop] =
        this.ruleFormAddGoods[prop].replace(
          /^(\d+)\.(\d\d).*$/,
          "$1.$2"
        ); //限制只能输入两个小数
      if (
        this.ruleFormAddGoods[prop].indexOf(".") < 0 &&
        this.ruleFormAddGoods[prop] != ""
      ) {
        //首位是0的话去掉
        this.ruleFormAddGoods[prop] = parseFloat(
          this.ruleFormAddGoods[prop]
        );
      }
    },
    filterGt0OrFixed0(prop, i) {
      if (prop !== "activityPrice" && prop !== "virtualExchangeNum") {
        this.ruleForm.spuInfoModelList[i][prop] =
          this.ruleForm.spuInfoModelList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      }

      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop].replace(/[^\d]+/g, "");
      this.ruleForm.spuInfoModelList[i][prop] =
        this.ruleForm.spuInfoModelList[i][prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    saveGoods(data) {
      console.log(data);
      // if (data.length > 0) {
      //   this.dialogVisible = false;
      //   this.ruleForm.spuInfoModelList.push(...data);
      //   this.ruleForm.spuInfoModelList = arrayUnique2(
      //     this.ruleForm.spuInfoModelList,
      //     "wxshopSkuId"
      //   );
      // } else {
      //   this.$message({
      //     message: "请选择商品",
      //     type: "warning",
      //   });
      // }
    },
    setLink(row) {
      // this.dialogVisible = false;
      // this.isRadio = false;
      console.log('row', row);
      this.currentRow = row
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.dialogVisible = false;
        this.wxshopSkuId = this.currentRow.wxshopSkuId;
        this.ruleForm.wxshopSpuName = this.currentRow.wxshopSpuName + this.currentRow.specIdGroupName;
        this.ruleForm.selectWxshopSkuId = row.wxshopSkuId;
        this.ruleForm.selectWxshopSpuId = row.wxshopSpuId;
      }
    },
    async deleteGoodChild(index, row) {
      let userName = getUserName();
      let params = {
        id: row.id,
        username: userName,
      }
      const { code } = await this.$store.dispatch("removeByModel", params);
      if ( code === "0" ) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.queryDetails();
      }
    },
    submitForm(formName,stay) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));          
          params.goodsMainImg = this.listHeaderImgUrl;
          params.deliveryMode = JSON.stringify(this.ruleForm.deliveryMode);
          params.addSpuInfoModelList = this.addSpuInfoModelList;
          console.log("params:", params);
          // return false;
          if (this.id) {
            console.log("修改");
            params.id = this.id;            
            params.removeGoodsIdList = this.removeGoodsIdList;
            params.spuInfoModelList = [];
            // 修改
            this.$store.dispatch("editLivePlan", params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                if(stay==='stay'){
                  this.queryDetails();
                }else{
                  this.$router.back(-1);
                }
              }
            });
          } else {
            // 新增和复制
            console.log("新增");
            this.$store.dispatch("addLivePlan", params).then((res) => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.back(-1);
              }
            });
          }
        } else {
          return false;
          // this.$message({
          //   message: "操作失败",
          //   type: "fail",
          // });
          // // this.$router.back(-1);
        }
      });
    },
    uploadSharePicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleForm.sharePic = jsonData.result;
        this.uploadShow = false;
      }
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning",
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        this.listHeaderImgUrl = jsonData.result;
      }
    },
    toggleShow() {
      this.show = !this.show;
    },
    // 过滤大于0且如果是小数保留两位
    filterGt0OrFixed3AddGoods(prop) {
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop].replace(/[^\d]/g, ""); //仅保留数字和"-"
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
    },
    filterGt0OrFixed4AddGoods(prop) {
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop].replace(/[^\d-]/g, ""); //仅保留数字和"-"
      this.ruleFormAddGoods[prop] = this.ruleFormAddGoods[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormAddGoods.spuMainPic = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormAddGoods.spuMainPic = "";
    },
    submitruleFormAddGoods(formName){
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("this.ruleFormAddGoods.deliveryMode:",this.ruleFormAddGoods.deliveryMode);
          console.log("this.deliveryList:",this.deliveryList);
          this.ruleFormAddGoods.deliveryMode.forEach(v=>{
            this.deliveryList.forEach(o=>{
              if(v===o.value){
                this.ruleFormAddGoods.deliveryModeName += o.name + "，"
              }
            })             
          })
          this.ruleFormAddGoods.spuSlideShowPicList = [];
          if(this.ruleFormAddGoods.spuMainPic){
            this.ruleFormAddGoods.spuSlideShowPicList.push(this.ruleFormAddGoods.spuMainPic);
          }
          let params = JSON.parse(JSON.stringify(this.ruleFormAddGoods));
          console.log("params:",params);
          params.deliveryMode = JSON.stringify(this.ruleFormAddGoods.deliveryMode);
          // this.ruleForm.spuInfoModelList.unshift(params);
          this.addSpuInfoModelList.unshift(params);
          this.dialogAddGoods = false;
          this.submitForm('ruleForm','stay')
        }
      })
    },
    async addLiveShow(index, row){
      let userName = getUserName();
      let params = {
        planId: this.id,
        liveShowWxshopSpuId: row.wxshopSpuId,
        username: userName,
      }
      const { code } = await this.$store.dispatch("liveShowWxshopSpuIdByPlanId", params);
      if (code === "0") {        
        await this.queryDetails();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }
    },
    async cancelLiveShow(index, row){
      let userName = getUserName();
      let params = {
        id: row.id,
        liveShow: "no",
        username: userName,
      }
      const { code } = await this.$store.dispatch("setLiveShowWxshopSpuIdById", params);
      if ( code === "0" ) {
        await this.queryDetails();
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }
    },
    async refreshStockNum(){
      await this.queryDetails();
      this.$message({
        message: "操作成功",
        type: "success",
      });
    },
    /**
     * @desc 选择闪电购对应的商品
    */
    selectGood() {
      // this.dialogVisible2 = true;
      this.dialogVisible = true
      // this.queryVirtualList();
    },
    /**
     * @desc 保存闪电购对应的商品
    */
    saveGoods2() {
      console.log('-this.currentRow-', this.currentRow);
      if (!this.currentRow.spuId) {
        this.$message({
          type: "warning",
          message: "请先选择商品"
        });
      } else {
        this.dialogVisible2 = false;
        this.wxshopSkuId = this.currentRow.wxshopSkuId;
        this.ruleForm.wxshopSpuName = this.currentRow.wxshopSpuName + this.currentRow.specIdGroupName;
      }
    },
    queryVirtualList() {
      let params = {
        pageSize: this.pageVirtualSize,
        pageNo: this.currentVirtualPage,
        spuType: "virtual"
      };
      const searchDialogCondition = JSON.parse(
        JSON.stringify(this.searchDialogCondition)
      );
      Object.assign(params, searchDialogCondition);
      this.$store.dispatch("virtualGoods", params);
    },
    getTransferResult(data) {
      this.ruleForm.rightIdList = data.map(v => v.plusRightId);
    },
    searchGoods() {
      this.currentVirtualPage = 1;
      this.queryVirtualList();
    },
    handleSizeVirtualChange(size) {
      this.currentVirtualPage = 1;
      this.pageSize = size;
      this.queryVirtualList();
    },
    pagingVirtual(page) {
      this.currentVirtualPage = page;
      this.queryVirtualList();
    },
    handleCurrentChange(row) {
      console.log(row);
      this.currentRow = row;
      if (row) {
        this.ruleForm.selectWxshopSkuId = row.wxshopSkuId;
        this.ruleForm.selectWxshopSpuId = row.wxshopSpuId;
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
  },
};
</script>

<style scoped lang="scss">
.add-goods-container {
  width: 1128px;
  flex-shrink: 0;
}
.priview {
  position: relative;
  width: 200px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priview2{
  position: relative;
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  overflow: hidden;
  img {
    width: 100%;
    max-height: 178px;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.quick-wrap {
  width: 570px;
  padding: 10px;
  // height: 64px;
  background: #F7F7F7;
  border-radius: 6px 6px 6px 6px;
  opacity: 1;
  .item {
    margin-bottom: 10px;
    &:last-of-type {
      margin-bottom: 0;
    }
    .label {
      margin-right: 10px;
      color: rgba(34, 34, 34, 1);
      font-size: 14px;
    }
    .content {
      .input-range {
        .el-input-number {
          width: 80px;
          /deep/ .el-input {
            width: 100%;
          }
          .el-input__inner {
            text-align: left;
          }
        }
      }
    }

  }
}
</style>
